/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Desktop_DescInputs */

const en_pc_online_desktop_desc = /** @type {(inputs: Pc_Online_Desktop_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The desktop app prints, reopens closed tabs, reveals files in their folder, and has a separate command-line tool for automation.`)
};

const zh_pc_online_desktop_desc = /** @type {(inputs: Pc_Online_Desktop_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌面版可以打印、重新打开已关闭的标签页、在文件夹中显示文件，并提供用于自动化的独立命令行工具。`)
};

/**
* | output |
* | --- |
* | "The desktop app prints, reopens closed tabs, reveals files in their folder, and has a separate command-line tool for automation." |
*
* @param {Pc_Online_Desktop_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_desktop_desc = /** @type {((inputs?: Pc_Online_Desktop_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Desktop_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_desktop_desc(inputs)
	return zh_pc_online_desktop_desc(inputs)
});
export { pc_online_desktop_desc as "pc.online.desktop_desc" }